import { cloneDeep } from 'lodash-es';

/* eslint-disable import/prefer-default-export */
/**
 * Shapes a user's message to the expected payload of the `/specialty-ai-search` fusion endpoint
 * @param {string} content
 * @returns {Object} payload
 * @returns {Object} payload.messages
 * @returns {string} payload.messages.role
 * @returns {string} payload.messages.content
 */
export const formatAiSearchPayload = ({ content, aiSearchKey }) => {
  if (typeof content !== 'string') return null;
  return {
    chatKey: aiSearchKey,
    messages: {
      role: 'user',
      content,
    },
  };
};

/**
 * Reformats the recommendations.specialties array
 * { id, name, description } => { specialtyId, specialtyName, description }
 */
export const formatAiSearchResponse = (response, availableSpecialties) => {
  const { specialties = [], subspecialties = [] } = response.recommendations;

  response.recommendations.specialties = specialties
    .map(({ id: specialtyId, name: specialtyName, description }) => {
      const output = {
        specialtyId,
        specialtyName,
        description,
      };

      return subspecialties.find((ss) => specialtyId === ss.parentSpecialtyId) ? null : output;
    })
    .filter((el) => el);

  subspecialties.forEach((ss) => {
    // grab parent spec from redux to match on returned subspecialties
    const parentSpecialty = availableSpecialties?.provider[ss.parentSpecialtyId];

    // grab matching subspecialty object for extra properties not returned in ai search
    const matchedSubspecialty = availableSpecialties?.provider[
      ss.parentSpecialtyId
    ]?.subspecialties.find((sub) => sub.subspecialtyId === ss.subspecialtyId);

    if (matchedSubspecialty) {
      // replace descriptions in redux with descriptions from ai-search in case of non-english speaking search
      const mutableMatchedSS = cloneDeep(matchedSubspecialty);
      mutableMatchedSS.description = ss?.description;

      // occasionally search will return two subspecialties with the same parent spec ex: 'my son has adhd'
      const parentSpecialtyInResponse = response.recommendations.specialties.find(
        (s) => s.specialtyId === ss.parentSpecialtyId
      );
      if (parentSpecialtyInResponse) {
        parentSpecialtyInResponse.subspecialties.push(mutableMatchedSS);
      } else {
        response.recommendations.specialties.push({
          description: ss.parentSpecialtyDescription,
          specialtyId: ss.parentSpecialtyId,
          specialtyName: parentSpecialty.specialtyName,
          subspecialties: [mutableMatchedSS],
        });
      }
    }
  });

  return response;
};
